"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* [DISABLED_TEMPORARILY] @ typescript-eslint /camelcase */
var adBannerModuleConfig = [
    {
        key: 'numPerRow',
        type: 'number',
        label_ar: 'Banners Per Row',
        label_en: 'Banners Per Row',
        required: true,
        min: 1,
        max: 12,
        default_value: 1,
        sort: 1,
    },
    {
        key: 'label',
        type: 'group',
        label_ar: 'Label',
        label_en: 'Label',
        required: false,
        sort: 2,
        values: [
            {
                key: 'text',
                type: 'string',
                label_en: 'Label Text',
                label_ar: 'Label Text',
                required: true,
                sort: 1,
            },
            {
                key: 'position',
                type: 'group',
                label_ar: 'Position',
                label_en: 'Position',
                required: false,
                sort: 2,
                values: [
                    {
                        key: 'bottom',
                        type: 'number',
                        label_en: 'Bottom',
                        label_ar: 'Bottom',
                        default_value: 0,
                        min: 0,
                        max: 15,
                        sort: 1,
                    },
                    {
                        key: 'right',
                        type: 'number',
                        label_en: 'Right',
                        label_ar: 'Right',
                        default_value: 0,
                        min: 0,
                        max: 15,
                        sort: 2,
                    },
                ],
            },
            {
                key: 'bgColor',
                type: 'color',
                label_en: 'Label Background Color',
                label_ar: 'Label Background Color',
                required: false,
                sort: 2,
            },
            {
                key: 'textColor',
                type: 'color',
                label_en: 'Label Text Color',
                label_ar: 'Label Text Color',
                required: false,
                sort: 3,
            },
        ],
    },
    {
        key: 'banners',
        type: 'array',
        label_ar: 'Banner',
        label_en: 'Banner',
        required: true,
        sort: 3,
        values: [
            {
                // key: 'imageUrl',
                key: 'slotId',
                type: 'string',
                label_ar: 'Slot ID',
                label_en: 'Slot ID',
                description_en: 'The ID given to you from Flipkart to display the Ad',
                description_ar: 'The ID given to you from Flipkart to display the Ad',
                required: true,
                sort: 1,
            },
            {
                // key: 'imageUrl',
                key: 'imagePath',
                type: 'image',
                max_width: 1440,
                label_ar: 'Fallback Image',
                label_en: 'Fallback Image',
                description_en: 'Recommended Size:<br/>Single Banner (Desktop) - 1440x250<br/>Single Banner (Mobile) - 800x250',
                description_ar: 'Recommended Size:<br/>Single Banner (Desktop) - 1440x250<br/>Single Banner (Mobile) - 800x250',
                required: true,
                sort: 2,
            },
            {
                key: 'linkUrl',
                type: 'url',
                label_ar: 'Fallback Link Url',
                label_en: 'Fallback Link Url',
                description_en: 'The URL may look more generic after saving, but it will point to the same page',
                description_ar: 'The URL may look more generic after saving, but it will point to the same page',
                required: false,
                sort: 3,
            },
            {
                key: 'titleText',
                type: 'string',
                label_ar: 'Title Text',
                label_en: 'Title Text',
                required: false,
                sort: 4,
            },
            {
                key: 'summaryText',
                type: 'string',
                label_ar: 'Subtitle Text',
                label_en: 'Subtitle Text',
                required: false,
                sort: 5,
            },
        ],
    },
    {
        key: 'bgColor',
        type: 'color',
        label_ar: 'Background Color',
        label_en: 'Background Color',
        required: false,
        default_value: '#FFFFFF',
        sort: 4,
    },
    {
        key: 'moduleHeader',
        type: 'group',
        label_ar: 'Module Header',
        label_en: 'Module Header',
        required: false,
        extra: true,
        sort: 5,
        values: [
            {
                key: 'titleText',
                type: 'string',
                label_ar: 'Title Text',
                label_en: 'Title Text',
                required: false,
                sort: 1,
            },
            {
                key: 'titleColor',
                type: 'color',
                label_ar: 'Title Text Color',
                label_en: 'Title Text Color',
                required: false,
                sort: 2,
            },
            {
                key: 'linkText',
                type: 'string',
                label_ar: 'CTA Text',
                label_en: 'CTA Text',
                required: false,
                sort: 3,
            },
            {
                key: 'linkUrl',
                type: 'url',
                label_ar: 'CTA Url',
                label_en: 'CTA Url',
                required: false,
                sort: 4,
            },
            {
                key: 'linkBgColor',
                type: 'color',
                label_ar: 'CTA Background Color',
                label_en: 'CTA Background Color',
                required: false,
                sort: 6,
            },
        ],
    },
    {
        key: 'textColor',
        type: 'color',
        label_ar: 'CTA Text Color',
        label_en: 'CTA Text Color',
        required: false,
        sort: 6,
    },
    // Inner Spacing is translated into value*5 px
    // Max value - 3 (20px)
    // Advanced setting
    {
        key: 'innerSpacing',
        type: 'number',
        label_ar: 'Inner Spacing (*5 px)',
        label_en: 'Inner Spacing (*5 px)',
        required: false,
        sort: 7,
        extra: true,
        default_value: 0,
        min: 0,
        max: 3,
    },
    // Outer Spacing is translated into value*5 px
    // Max value - 15 (80px)
    // Advanced setting
    {
        key: 'outerSpacing',
        type: 'group',
        label_ar: 'Outer Spacing (*5 px)',
        label_en: 'Outer Spacing (*5 px)',
        required: false,
        sort: 8,
        extra: true,
        values: [
            {
                key: 'top',
                type: 'number',
                label_ar: 'Top',
                label_en: 'Top',
                required: false,
                sort: 1,
                default_value: 3,
                min: 0,
                max: 15,
            },
            {
                key: 'bottom',
                type: 'number',
                label_ar: 'Bottom',
                label_en: 'Bottom',
                required: false,
                sort: 2,
                default_value: 3,
                min: 0,
                max: 15,
            },
        ],
    },
];
exports.default = adBannerModuleConfig;
//# sourceMappingURL=config.js.map